import React, { useContext, useEffect, useState } from 'react'
import { useMediaQuery } from 'react-responsive';
import { Button, Card, Col, Container, Form, InputGroup, Row, Spinner, Table } from 'react-bootstrap';
import Swal from 'sweetalert2';
import { Formik } from 'formik';
import { FaWindowClose } from 'react-icons/fa';
import { BsFillPencilFill } from 'react-icons/bs';
import { ModalTambahPcpDetailDatabase, ModalUbahPcpDetail } from '../../../components/Modal';
import { AuthContext, ThemeContext } from '../../../auth';
import { HeaderWeb, SidebarComponent } from '../../../components';
import { useNavigate, useParams } from 'react-router-dom';
import { axiosAuth } from '../../../api';

function PcpPenjualanEdit() {

    const { id } = useParams();
    const { theme } = useContext(ThemeContext);
    const { showSidebar, accessToken, userInfo } = useContext(AuthContext);
    const isMobile = useMediaQuery({ maxWidth: 1024 });
    const [disabled, setDisabled] = useState(false);
    const [isSubmitting, setIsSubmitting] = useState(false);

    const [pcpData, setPcpData] = useState({});
    const [pcpDetail, setPcpDetail] = useState([]);
    const [listCategory, setListCategory] = useState([]);
    const [wapu, setWapu] = useState(pcpData?.isWapu || false);

    const retrievePCP = () => {

        axiosAuth.get(`/api/pcp?leadId=${id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },

            })
            .then(res => {

                setPcpData(res.data.data);

            }).catch(err => {
                console.error(err);

            })
    };

    const retrievePCPDetail = () => {

        axiosAuth.get(`/api/pcp/details?pcpId=${pcpData?.id}`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,

                },

            })
            .then(res => {

                setPcpDetail(res.data.data);

            }).catch(err => {
                console.error(err);

            })
    };

    const retrieveCategoryProduct = () => {

        axiosAuth.get(`/api/pcp/categories`,
            {
                headers:
                {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,

                },

            })
            .then(res => {

                // setListCategory(res.data.data);

                const filteredData = res.data.data.filter((category) => category?.categoryName != 'Solusi');

                setListCategory(filteredData);

            }).catch(err => {
                console.error(err);

            })
    };

    useEffect(() => {
        if (accessToken !== undefined && id !== undefined) retrievePCP();
    }, [accessToken, id]);

    useEffect(() => {
        if (accessToken !== undefined && pcpData?.id !== undefined) retrievePCPDetail();
    }, [accessToken, pcpData?.id]);

    useEffect(() => {
        if (accessToken !== undefined && pcpData !== undefined) retrieveCategoryProduct();
    }, [accessToken]);

    const defaultValue = {
        projectName: pcpData?.projectName || "",
        requestType: pcpData?.requestType || "",
        description: pcpData?.description || "",
        franco: pcpData?.franco || "",
    };

    const [showAddPcpDetail, setShowAddPcpDetail] = useState(false);

    const handleShowPcpDetail = () => {
        setShowAddPcpDetail(true)
    };

    const [rowSelected, setRowSelected] = useState({});
    const [showEditPcpDetail, setShowEditPcpDetail] = useState(false);

    const handleShowEditPcpDetail = (item) => {
        setShowEditPcpDetail(true);
        setRowSelected(item);
    };

    const handleDelete = async (itemId) => {

        const result = await Swal.fire({
            title: 'Apakah anda yakin ingin menghapus produk ini?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonText: 'Ya, hapus produk ini!',
            cancelButtonText: 'Batalkan',
        });

        if (result.isConfirmed) {

            try {
                const response = await axiosAuth.delete(`/api/pcp/details/${itemId}`,
                    {
                        headers: {
                            'Access-Control-Allow-Origin': '*',
                            withCredentials: true,
                            Authorization: `Bearer ${accessToken}`,
                        },
                    }
                );

                Swal.fire('Berhasil!', 'Produk berhasil dihapus', 'success');
                retrievePCPDetail();

            } catch (err) {
                console.error(err);
                Swal.fire('Error', 'Terjadi kesalahan saat menghapus produk!', 'error');
            }
        } else {
            <></>
        }
    };

    const numberFormat = (value) =>
        new Intl.NumberFormat('IN-ID', {
            style: 'currency',
            currency: 'IDR'
        }).format(value);

    const navigate = useNavigate();

    const handleBack = () => {
        navigate(-1)
    }

    const totalHargaJual = pcpDetail?.reduce((total, item) => total + (item.subtotal || 0), 0) || 0;

    const totalHargaBeli = pcpDetail?.reduce((total, item) => total + ((item.buyingPrice * item.quantity) || 0), 0);

    const [ppnPercentage, setPpnPercentage] = useState(pcpData?.ppnPercentage || 11);

    const ppnAmount = totalHargaJual * (ppnPercentage / 100);

    const grandTotalRaw = totalHargaJual + ppnAmount;

    // Pembulatan grandTotal
    const remainder = grandTotalRaw % 100;
    const grandTotal = remainder >= 50
        ? Math.round(grandTotalRaw + (100 - remainder))
        : Math.round(grandTotalRaw - remainder);

    const overHead = totalHargaJual * 0.03;

    const [edlCost, setEdlCost] = useState(0);

    const [deliveryCost, setDeliveryCost] = useState(0);

    const [financialCost, setFinancialCost] = useState(0);

    const [otherFinancialCost, setOtherFinancialCost] = useState(0);

    const [otherAllowance, setOtherAllowance] = useState(0);

    const subTotalCost =
        (parseFloat(overHead) || 0) +
        (parseFloat(edlCost) || 0) +
        (parseFloat(deliveryCost) || 0) +
        (parseFloat(financialCost) || 0) +
        (parseFloat(otherFinancialCost) || 0) +
        (parseFloat(otherAllowance) || 0);

    const grossMargin = parseFloat(totalHargaJual) - parseFloat(totalHargaBeli) || 0;

    const nettMargin = parseFloat(grossMargin) - parseFloat(subTotalCost) || 0;


    useEffect(() => {

        setPpnPercentage(pcpData?.ppnPercentage || 11);

        setEdlCost(pcpData?.externalDirectLabor || 0);

        setDeliveryCost(pcpData?.deliveryCost || 0);

        setFinancialCost(pcpData?.financialCost || 0);

        setOtherFinancialCost(pcpData?.otherFinancialCost || 0);

        setOtherAllowance(pcpData?.otherAllowance || 0);

        if (pcpData && pcpData.isWapu !== undefined) {
            setWapu(pcpData.isWapu);
        }

    }, [pcpData]);

    function handleChangeEDL(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setEdlCost(numericValue);
    }

    function handleChangeDeliveryCost(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setDeliveryCost(numericValue);
    }

    function handleChangeFinancialCost(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setFinancialCost(numericValue);
    }

    function handleChangeOtherFinanceCost(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setOtherFinancialCost(numericValue);
    }

    function handleChangeOtherAllowance(e) {
        const inputValue = e.target.value;
        const numericValue = parseFloat(inputValue.replace(/[^\d]/g, '')) || 0;
        setOtherAllowance(numericValue);
    }

    const nettPercentage = parseInt(nettMargin) / parseInt(totalHargaJual) * 100 || 0;

    const calculateMarginTotal = (sellingPrice, buyingPrice) => {
        const sell = parseFloat(sellingPrice || 0);
        const buy = parseFloat(buyingPrice || 0);
        return ((sell - buy) / (sell || 1)) * 100;
    };

    const getThresholdMargin = (categoryId, isWapu) => {
        switch (categoryId) {
            case 1:
                return isWapu ? 16 : 10;
            case 2:
                return isWapu ? 31 : 20;
            case 3:
                return isWapu ? 41 : 30;
            default:
                return 0;
        }
    };

    const handleSubmitPCP = async (values) => {

        setIsSubmitting(true);
        setDisabled(true);

        const updatedPcpDetail = pcpDetail.map((item) => {
            const marginTotal = calculateMarginTotal(item.sellingPrice, item.buyingPrice);
            const thresholdMargin = getThresholdMargin(item?.category?.id, pcpData?.isWapu);

            const marginValidate = marginTotal.toFixed(2) > thresholdMargin;

            return {
                ...item,
                marginTotal,
                thresholdMargin,
                marginValidate,
            };
        });

        const checkingMargin = updatedPcpDetail.filter(item => item.marginValidate === false);

        const dataPCP = {
            projectName: values.projectName,
            description: values.description,
            salesTotal: parseInt(totalHargaJual || 0),
            ppn: ppnAmount,
            ppnPercentage: parseInt(ppnPercentage),
            grandTotal: grandTotal,
            isWapu: wapu,
            overhead: overHead || 0,
            deliveryCost: parseInt(deliveryCost || 0),
            externalDirectLabor: parseInt(edlCost || 0),
            financialCost: parseInt(financialCost || 0),
            otherFinancialCost: parseInt(otherFinancialCost || 0),
            otherAllowance: parseInt(otherAllowance || 0),
            username: userInfo?.username,
            purchasesTotal: totalHargaBeli,
            status: checkingMargin.length !== 0 || nettMargin <= 300000 ? 'pending' : !values.description ? 'approved' : 'pending',
        };

        try {

            const response = await axiosAuth.put(`/api/pcp/${pcpData?.id}`, dataPCP, {
                headers: {
                    'Access-Control-Allow-Origin': '*',
                    'Content-Type': 'application/json',
                    withCredentials: true,
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            handleBack();

            Swal.fire({
                icon: 'success',
                title: 'Berhasil mengupdate Pcp',
                showConfirmButton: true,
            });

            setIsSubmitting(false);
            setDisabled(false);

        } catch (err) {
            console.error(err);

            Swal.fire({
                icon: 'error',
                title: 'Oops...',
                text: 'Terjadi kesalahan saat mengupdate Pcp',
            });

            setIsSubmitting(false);
            setDisabled(false);

        } finally {

            setIsSubmitting(false);
            setDisabled(false);

        }

    };

    const formStyles = {
        label: {
            fontFamily: 'Poppins-Medium',
            color: theme === 'light' ? '#FFFFFF' : '#222222',
        },
        input: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputQty: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputBodyGroup: {
            color: theme === 'light' ? '#FFFFFF' : '#222222',
            fontFamily: 'Poppins-Regular',
            maxWidth: '90px',
            maxHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
        inputNettmargin: {
            color: nettMargin <= 300000
                ? 'red'
                : theme === 'light'
                    ? '#FFFFFF'
                    : '#222222',
            fontFamily: 'Poppins-Regular',
            minHeight: '50px',
            borderColor: '#ced4da',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        },
    };

    const selectStyles = {
        control: (cityided, state) => ({
            ...cityided,
            minHeight: '50px',
            border: state.isFocused ? '1px solid #80bdff' : '1px solid #ced4da',
            boxShadow: state.isFocused ? '0 0 0 0.3rem rgba(0, 123, 255, 0.25)' : null,
            '&:hover': {
                borderColor: '#80bdff',
            },
            textAlign: 'left',
            fontFamily: 'Poppins-Regular',
            background: theme === 'light' ? '#212529' : '#FFFFFF',
        }),
        option: (provided, state) => ({
            ...provided,
            color: state.isSelected ? '#fff' : '#333',
            background: state.isSelected ? '#007bff' : state.isFocused ? '#f5f5f5' : '#fff',
            fontFamily: 'Poppins-Regular',
        }),
        singleValue: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
        input: (provided) => ({
            ...provided,
            color: theme === 'light' ? '#FFFFFF' : '#222',
            fontFamily: 'Poppins-Regular',
        }),
    };

    return (

        <div style={{
            overflowX: 'hidden',
            maxWidth: '100vw',
            backgroundColor: theme === 'light' ? '#121212' : '#FFFFFF',
            transition: '0.8s'
        }}>
            <SidebarComponent />
            <div id={theme === 'light' ? 'containerAppDark' : 'containerAppLight'}
                style={{
                    width: isMobile ? '100%' : `calc(100% - ${showSidebar ? '78px' : '190px'})`,
                    marginLeft: isMobile ? '0px' : showSidebar ? '78px' : '190px',
                    transition: '0.8s'
                }}>
                <div className={isMobile ? 'ms-2' : 'ms-3 me-2'}>
                    <Row>
                        <Col xs={6} lg={6} className='text-start'>
                            <h3 className='pt-4' style={{ fontFamily: 'Poppins-Medium', fontSize: isMobile ? '25px' : '38px', color: theme === 'light' ? '#FFFFFF' : '', marginBottom: '0px' }}>
                                Update PCP Penjualan
                            </h3>
                        </Col>
                        <Col xs={6} lg={6} className={isMobile === false ? 'text-end my-auto' : 'text-end my-auto pt-4'}>
                            <HeaderWeb />
                        </Col>
                    </Row>
                </div>
                <Formik
                    initialValues={defaultValue}
                    enableReinitialize={true}
                    onSubmit={handleSubmitPCP}
                >
                    {({
                        handleSubmit,
                        handleChange,
                        values
                    }) => {

                        return (
                            <Form onSubmit={handleSubmit}>
                                <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4'}>
                                    <Row>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='customer'>Customer</Form.Label>
                                            <Form.Control
                                                id='customer'
                                                type="text"
                                                readOnly
                                                value={
                                                    pcpData?.lead?.customer?.title?.titleName === "Others"
                                                        ? pcpData?.lead?.customer?.name
                                                        : `${pcpData?.lead?.customer?.title?.titleName}. ${pcpData?.lead?.customer?.name}`
                                                }
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='project'>Nama Projek*</Form.Label>
                                            <Form.Control
                                                id='project'
                                                type="text"
                                                value={values.projectName}
                                                onChange={handleChange("projectName")}
                                                required
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={3} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='top'>Term of Payment*</Form.Label>
                                            <InputGroup >
                                                <Form.Control
                                                    id="top"
                                                    type="text"
                                                    value={pcpData?.lead?.customer?.top || ''}
                                                    readOnly
                                                    placeholder="Term of Payment"
                                                    style={formStyles.input}
                                                />
                                                <InputGroup.Text
                                                    style={formStyles.input}
                                                    id="basic-addon1"
                                                >
                                                    Hari
                                                </InputGroup.Text>
                                            </InputGroup>
                                        </Col>
                                        <Col xs={12} lg={1} className="mb-3">
                                            <Form.Label style={formStyles.label}>Wapu</Form.Label>
                                            <Form.Check
                                                type='checkbox'
                                                id='default-checkbox'
                                                onChange={(e) => setWapu(e.target.checked)}
                                                checked={wapu}
                                                style={formStyles.label}
                                            // disabled={pcpDetail.length !== 0}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label}>Franco*</Form.Label>
                                            <Form.Control
                                                id='franco'
                                                type="text"
                                                value={values.franco}
                                                onChange={handleChange("franco")}
                                                required
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Label style={formStyles.label} htmlFor='status'>Status Pcp</Form.Label>
                                            <Form.Control
                                                id='status'
                                                type="text"
                                                defaultValue={pcpData?.status || ''}
                                                readOnly
                                                style={formStyles.input}
                                            />
                                        </Col>
                                        <Col xs={12} lg={4} className="mb-3">
                                            <Form.Group >
                                                <Form.Label style={formStyles.label} htmlFor='description'>Syarat dan ketentuan tambahan</Form.Label>
                                                <Form.Control
                                                    id="description"
                                                    as="textarea"
                                                    rows={3}
                                                    value={values.description}
                                                    onChange={handleChange("description")}
                                                    placeholder="Syarat dan ketentuan tambahan"
                                                    style={formStyles.input}
                                                />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </div>

                                <div className={isMobile ? 'ms-1 mt-4' : 'ms-3 mt-4 me-3'}>
                                    <h3 className='text-center' style={{ fontFamily: 'Poppins-Medium', color: theme === 'light' ? '#FFFFFF' : '#222', fontSize: isMobile ? '25px' : '38px' }}>
                                        PCP Detail
                                    </h3>
                                    <div>
                                        <Row>
                                            <Col xs={12} lg={6} className='text-start'>
                                                <Button
                                                    variant='btn'
                                                    id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                    onClick={handleShowPcpDetail}
                                                >
                                                    Tambah
                                                </Button>
                                            </Col>
                                        </Row>
                                    </div>
                                    <Table className='mt-4' bordered responsive data-bs-theme={theme === "light" ? "dark" : "light"}>
                                        <thead>
                                            <tr style={{ fontFamily: 'Poppins-Regular', textAlign: 'center' }}>
                                                <th
                                                    style={{
                                                        textAlign: 'left'
                                                    }}
                                                >
                                                    Nama Produk
                                                </th>
                                                <th>Jenis Produk</th>
                                                <th
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    Harga Beli
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    Harga Jual
                                                </th>
                                                <th>Qty</th>
                                                <th
                                                    style={{
                                                        textAlign: 'right'
                                                    }}
                                                >
                                                    Sub Total
                                                </th>
                                                <th
                                                    style={{
                                                        textAlign: 'center'
                                                    }}
                                                >
                                                    %
                                                </th>
                                                <th>Ubah</th>
                                                <th>Hapus</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {pcpDetail.map((item, index) => {
                                                const marginTotal = (
                                                    (parseFloat(item.sellingPrice || 0) - parseFloat(item.buyingPrice || 0)) /
                                                    (parseFloat(item.sellingPrice || 1))
                                                ) * 100;

                                                return (
                                                    <tr key={index} style={{ fontFamily: 'Poppins-Light', textAlign: 'center' }}>
                                                        <td style={{
                                                            textAlign: 'left',
                                                            width: '350px'
                                                        }}>
                                                            {item?.productName}
                                                        </td>
                                                        <td>
                                                            {item?.category?.categoryName}
                                                        </td>
                                                        <td style={{
                                                            textAlign: 'right'
                                                        }}>
                                                            {numberFormat(item.buyingPrice)}
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'right'
                                                            }}
                                                        >
                                                            {numberFormat(item.sellingPrice)}
                                                        </td>
                                                        <td>
                                                            {item.quantity || 0}
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'right'
                                                            }}
                                                        >
                                                            {numberFormat(item.subtotal || 0)}
                                                        </td>
                                                        <td
                                                            style={{
                                                                textAlign: 'center'
                                                            }}
                                                        >
                                                            <span style={{
                                                                color: (() => {
                                                                    const thresholdMargin = (() => {
                                                                        switch (item?.category?.id) {
                                                                            case 1:
                                                                                return wapu ? 16 : 10;
                                                                            case 2:
                                                                                return wapu ? 31 : 20;
                                                                            case 3:
                                                                                return wapu ? 41 : 30;
                                                                            default:
                                                                                return 0;
                                                                        }
                                                                    })();

                                                                    return marginTotal <= thresholdMargin ? '#FF0060' : '#16C47F';

                                                                })()
                                                            }}>
                                                                {marginTotal.toFixed(2) ? `${marginTotal.toFixed(2)}%` : '0%'}
                                                            </span>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <Button
                                                                    variant='btn'
                                                                    onClick={() => handleShowEditPcpDetail(item)}
                                                                    style={{
                                                                        border: 'none',
                                                                        backgroundColor: 'transparent',
                                                                    }}
                                                                >
                                                                    &nbsp;<BsFillPencilFill size={20} color={theme === 'light' ? '#12B3ED' : '#006CB8'} />&nbsp;
                                                                </Button>
                                                            </div>
                                                        </td>
                                                        <td>
                                                            <div>
                                                                <Button
                                                                    variant='btn'
                                                                    onClick={() => handleDelete(item?.id)}
                                                                    style={{
                                                                        border: 'none',
                                                                        backgroundColor: 'transparent',
                                                                    }}
                                                                >
                                                                    &nbsp;<FaWindowClose size={20} color='#FF0060' />&nbsp;
                                                                </Button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </tbody>
                                    </Table>
                                    <div className='mt-5'>
                                        <Row>
                                            <Col xs={12} lg={4} className={isMobile ? 'mb-5 text-start' : 'text-start'}>
                                                <Card
                                                    data-bs-theme={theme === 'light' ? 'dark' : ''}>
                                                    <Card.Body>
                                                        <div>
                                                            <Form.Label style={formStyles.label} htmlFor='totalSelling'>Total Harga Jual</Form.Label>
                                                            <Form.Control
                                                                id='totalSelling'
                                                                type='text'
                                                                className='mb-3'
                                                                value={numberFormat(totalHargaJual) || ''}
                                                                readOnly
                                                                style={formStyles.input}
                                                            />
                                                            <Form.Label style={formStyles.label} htmlFor='ppn'>PPN%</Form.Label>
                                                            <Form.Control
                                                                id='ppn'
                                                                type='text'
                                                                className='mb-3'
                                                                value={ppnPercentage}
                                                                onChange={(e) => {
                                                                    const value = e.target.value;
                                                                    if (/^\d*$/.test(value)) {
                                                                        setPpnPercentage(value);
                                                                    }
                                                                }}
                                                                required
                                                                style={formStyles.input}
                                                            />
                                                            <Form.Label style={formStyles.label} htmlFor='ppnValue'>PPN Amount</Form.Label>
                                                            <Form.Control
                                                                id='ppnValue'
                                                                type='text'
                                                                className='mb-3'
                                                                value={numberFormat(ppnAmount)}
                                                                readOnly
                                                                style={formStyles.input}
                                                            />
                                                            <Form.Label style={formStyles.label} htmlFor='grandTotal'>Grand Total</Form.Label>
                                                            <Form.Control
                                                                id='grandTotal'
                                                                type='text'
                                                                className='mb-3'
                                                                value={numberFormat(grandTotal)}
                                                                readOnly
                                                                style={formStyles.input}
                                                            />
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                            </Col>
                                            <Col xs={12} lg={2} ></Col>
                                            <Col xs={12} lg={6} >
                                                <Card
                                                    data-bs-theme={theme === 'light' ? 'dark' : ''}
                                                >
                                                    <Card.Body>
                                                        <div>
                                                            <Row>
                                                                <Col xs={12} lg={6}>
                                                                    <Form.Label style={formStyles.label} htmlFor='overHead'>Over Head (3%)</Form.Label>
                                                                    <Form.Control
                                                                        id='overHead'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={numberFormat(overHead) || numberFormat(0)}
                                                                        readOnly
                                                                        style={formStyles.input}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} lg={6}>
                                                                    <Form.Label style={formStyles.label} htmlFor='edlCost'>External Direct Labor Cost</Form.Label>
                                                                    <Form.Control
                                                                        id='edlCost'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        onChange={handleChangeEDL}
                                                                        value={`Rp ${edlCost ? edlCost.toLocaleString('id-ID') : '0,00'}`}
                                                                        required
                                                                        style={formStyles.input}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} lg={6}>
                                                                    <Form.Label style={formStyles.label} htmlFor='delivCost'>Delivery Cost</Form.Label>
                                                                    <Form.Control
                                                                        id='delivCost'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        onChange={handleChangeDeliveryCost}
                                                                        value={`Rp ${deliveryCost ? deliveryCost.toLocaleString('id-ID') : '0,00'}`}
                                                                        required
                                                                        style={formStyles.input}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} lg={6}>
                                                                    <Form.Label style={formStyles.label} htmlFor='financeCost'>Financial Cost</Form.Label>
                                                                    <Form.Control
                                                                        id='financeCost'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        onChange={handleChangeFinancialCost}
                                                                        value={`Rp ${financialCost ? financialCost.toLocaleString('id-ID') : '0,00'}`}
                                                                        required
                                                                        style={formStyles.input}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} lg={6}>
                                                                    <Form.Label style={formStyles.label} htmlFor='otherFinanceCost'>Other Financial Cost</Form.Label>
                                                                    <Form.Control
                                                                        id='otherFinanceCost'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        onChange={handleChangeOtherFinanceCost}
                                                                        value={`Rp ${otherFinancialCost ? otherFinancialCost.toLocaleString('id-ID') : '0,00'}`}
                                                                        required
                                                                        style={formStyles.input}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} lg={6}>
                                                                    <Form.Label style={formStyles.label} htmlFor='otherAllow'>Other Allowance</Form.Label>
                                                                    <Form.Control
                                                                        id='otherAllow'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        onChange={handleChangeOtherAllowance}
                                                                        value={`Rp ${otherAllowance ? otherAllowance.toLocaleString('id-ID') : '0,00'}`}
                                                                        required
                                                                        style={formStyles.input}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} lg={6}>
                                                                    <Form.Label style={formStyles.label} htmlFor='subTotalCost'>Sub Total Cost</Form.Label>
                                                                    <Form.Control
                                                                        id='subTotalCost'
                                                                        type='text'
                                                                        className='mb-3'
                                                                        value={numberFormat(subTotalCost) || numberFormat(0)}
                                                                        readOnly
                                                                        style={formStyles.input}
                                                                    />
                                                                </Col>
                                                                <Col xs={12} lg={6}>
                                                                    <Form.Label style={formStyles.label} htmlFor='nettMargin'>Nett Margin</Form.Label>
                                                                    <InputGroup className="mb-3">
                                                                        <Form.Control
                                                                            id='nettMargin'
                                                                            type='text'
                                                                            className='mb-3'
                                                                            value={numberFormat(nettMargin) || '0,00'}
                                                                            readOnly
                                                                            style={formStyles.inputNettmargin}
                                                                        />
                                                                        <InputGroup.Text
                                                                            id="basic-addon1"
                                                                            style={formStyles.inputBodyGroup}
                                                                        >
                                                                            {nettPercentage.toFixed(2) + '%'}
                                                                        </InputGroup.Text>
                                                                    </InputGroup>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </Card.Body>
                                                </Card>
                                                <div className='text-end mt-4 mb-3'>
                                                    {isSubmitting ? (
                                                        <Button
                                                            id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                            variant='btn'
                                                            disabled
                                                            style={{ minWidth: '90px' }}
                                                        >
                                                            <Spinner
                                                                animation="border"
                                                                size='sm'
                                                            />
                                                        </Button>
                                                    ) : (
                                                        <Button
                                                            variant='btn'
                                                            id={theme === 'light' ? 'actionButtonModalDark' : 'actionButtonModalLight'}
                                                            type='submit'
                                                            disabled={disabled ||
                                                                pcpDetail == 0
                                                            }
                                                        >
                                                            Simpan
                                                        </Button>
                                                    )}
                                                    <Button
                                                        variant='secondary'
                                                        className='ms-3'
                                                        onClick={handleBack}
                                                        style={{ fontFamily: 'Poppins-Regular', minHeight: '45px' }}
                                                        disabled={pcpData?.grandTotal != grandTotal}
                                                    >
                                                        Kembali
                                                    </Button>
                                                </div>
                                            </Col>
                                        </Row>
                                    </div>
                                </div>
                            </Form>
                        );
                    }}
                </Formik>
            </div>

            <ModalTambahPcpDetailDatabase
                showAddPcpDetail={showAddPcpDetail}
                setShowAddPcpDetail={setShowAddPcpDetail}
                listCategory={listCategory}
                formStyles={formStyles}
                selectStyles={selectStyles}
                pcpData={pcpData}
                accessToken={accessToken}
                retrievePCPDetail={retrievePCPDetail}
            />

            <ModalUbahPcpDetail
                rowSelected={rowSelected}
                pcpData={pcpData}
                showEditPcpDetail={showEditPcpDetail}
                setShowEditPcpDetail={setShowEditPcpDetail}
                listCategory={listCategory}
                formStyles={formStyles}
                selectStyles={selectStyles}
                retrievePCPDetail={retrievePCPDetail}
            />
        </div >
    )
}

export default PcpPenjualanEdit


